import Icon from "@ant-design/icons";
import { ReactComponent as FacebookSvg } from "./svg/facebook.svg";

const FacebookIcon = (props) => <Icon component={FacebookSvg} {...props} />;

export default FacebookIcon;
